module.exports = __webpack_public_path__ + "img/arrow-up-right.a2560bf5.svg";